

module.exports = __webpack_require__.stylable.create(
    "PaymentCheckout1835096417",
    {"classes":{"root":"PaymentCheckout1835096417__root","title":"PaymentCheckout1835096417__title","duration":"PaymentCheckout1835096417__duration","priceContainer":"PaymentCheckout1835096417__priceContainer","separator":"PaymentCheckout1835096417__separator","priceTitle":"PaymentCheckout1835096417__priceTitle","priceValue":"PaymentCheckout1835096417__priceValue"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "PaymentCheckout1835096417",
    null
);
